import { useFetch } from "../../../hooks/api";
import { useAppSelector } from "../../../redux/hooks";

export const useAdPlanTags = (enabled = false) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const params = { marketplace: marketPlace };

  const { data, isLoading } = useFetch(["allAdTags"], "/ad_tags", params, {
    select: (res) => {
      return res.data ?? [];
    },
    enabled: enabled,
    default: [],
  });

  return { data, isLoading };
};
